import * as Types from '../../generated/types';

import gql from 'graphql-tag';
import * as Urql from '@/urql/urqlWrapper';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type IPhoneVerificationFormSendPhoneVerificationMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
}>;


export type IPhoneVerificationFormSendPhoneVerificationMutation = { __typename?: 'Mutation', createTokenVerification: { __typename?: 'CreateVerificationResponse', success: boolean, errors?: Array<{ __typename?: 'DefaultError', message: string, stackTrace?: string | null }> | null } };

export type IPhoneVerificationFormCheckPhoneVerificationMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
  code: Types.Scalars['String']['input'];
}>;


export type IPhoneVerificationFormCheckPhoneVerificationMutation = { __typename?: 'Mutation', checkTokenVerification: { __typename?: 'CheckVerificationResponse', success: boolean, errors?: Array<{ __typename?: 'DefaultError', message: string, stackTrace?: string | null }> | null } };


export const PhoneVerificationFormSendPhoneVerificationDocument = gql`
    mutation PhoneVerificationFormSendPhoneVerification($phoneNumber: String!) {
  createTokenVerification(input: {phoneNumber: $phoneNumber}) {
    success
    errors {
      message
      stackTrace
    }
  }
}
    `;

export function usePhoneVerificationFormSendPhoneVerificationMutation() {
  return Urql.useMutation<IPhoneVerificationFormSendPhoneVerificationMutation, IPhoneVerificationFormSendPhoneVerificationMutationVariables>(PhoneVerificationFormSendPhoneVerificationDocument);
};
export const PhoneVerificationFormCheckPhoneVerificationDocument = gql`
    mutation PhoneVerificationFormCheckPhoneVerification($phoneNumber: String!, $code: String!) {
  checkTokenVerification(input: {phoneNumber: $phoneNumber, code: $code}) {
    success
    errors {
      message
      stackTrace
    }
  }
}
    `;

export function usePhoneVerificationFormCheckPhoneVerificationMutation() {
  return Urql.useMutation<IPhoneVerificationFormCheckPhoneVerificationMutation, IPhoneVerificationFormCheckPhoneVerificationMutationVariables>(PhoneVerificationFormCheckPhoneVerificationDocument);
};